import { ReactNode } from 'react';

import { Box, BoxProps, CheckOutline, forwardRef } from '@bonusly/design-system';

interface LabelPillProps extends BoxProps {
	readOnly?: boolean;
	isSelected?: boolean;
	children: ReactNode;
	handleSelection?: VoidFunction;
}
export const LabelPill = forwardRef<LabelPillProps, 'button'>(({ children, readOnly, isSelected, handleSelection, ...rest }, ref) => {
	return (
		<Box
			alignItems="center"
			ref={ref}
			borderRadius="full"
			borderColor={readOnly || isSelected ? 'transparent' : 'gray.400'}
			borderWidth={readOnly || isSelected ? undefined : 1}
			color={readOnly || isSelected ? 'primary.fgStrong' : 'secondary.fg'}
			bg={readOnly || isSelected ? 'primary.bgAlpha' : 'white'}
			_hover={{
				bg: readOnly || isSelected ? undefined : 'secondary.bgAlphaHover',
			}}
			cursor={readOnly ? 'default' : 'pointer'}
			transitionProperty="common"
			transitionDuration="normal"
			onClick={handleSelection}
			justifyContent="center"
			display="inline-flex"
			whiteSpace="nowrap"
			gap={1}
			px={3}
			{...rest}
		>
			{!readOnly && isSelected && <CheckOutline size="sm" />}
			{children}
		</Box>
	);
});
